// Permessi AGENCY lato client — SOLO per nascondere/mostrare la UI.
// L'autorizzazione autoritativa resta server-side (403 sugli endpoint).
export const AGENCY_PERMS = {
  overview: "agency.receptionist.overview",
  pipeline: "agency.receptionist.pipeline",
  leadInbox: "agency.receptionist.lead_inbox",
  calendar: "agency.receptionist.calendar",
  callbacks: "agency.receptionist.callbacks",
  aiBot: "agency.receptionist.ai_bot",
  settings: "agency.receptionist.settings",
};

export const RECEPTIONIST_PERM_LIST = [
  { key: AGENCY_PERMS.overview, label: "Panoramica" },
  { key: AGENCY_PERMS.pipeline, label: "Pipeline" },
  { key: AGENCY_PERMS.leadInbox, label: "Lead Inbox" },
  { key: AGENCY_PERMS.calendar, label: "Calendario" },
  { key: AGENCY_PERMS.callbacks, label: "Richiami" },
  { key: AGENCY_PERMS.aiBot, label: "AI Bot" },
  { key: AGENCY_PERMS.settings, label: "Impostazioni" },
];

export function hasAgencyPerm(user, perm) {
  if (!user || !perm) return false;
  if (user.role === "agency_admin") return true;
  const perms = user.agency_permissions || [];
  return perms.includes("*") || perms.includes(perm);
}
